import styled from 'styled-components';

const Column = styled.div`
  flex: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const NewContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const InfoWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  margin-top: 16px;
`;

export { Column, Content, FormContainer, InfoWrapper, NewContactForm, Row };
